import i18next from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
const keyPrefix = 'detach_user_departments';

export const detachUserDepartmentsTranslation = i18next.getFixedT(null, namespace, keyPrefix);

export const useDetachUserDepartmentsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Открепить пользователя от подразделения',
    toast_success: 'Подразделение успешно удалено',
    toast_error: 'Не удалось удалить подразделение',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Detach user from department',
    toast_success: 'Department has been successfully deleted',
    toast_error: 'Failed to delete department',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Desvincular usuário do departamento',
    toast_success: 'O departamento foi removido com sucesso',
    toast_error: 'Não foi possível remover o departamento',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Desvincular usuario del departamento',
    toast_success: 'El departamento se ha eliminado correctamente',
    toast_error: 'No se pudo eliminar el departamento',
  },
}) : {}) as Record<string, unknown>;
